import React from "react";
import { Navbar, Container, Nav, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { authAPI, getUser } from "../services/api";
import { useLanguage } from "../i18n/LanguageContext";
import LanguageSelector from "./LanguageSelector";

interface NavigationProps {
  onLogout: () => void;
}

const Navigation: React.FC<NavigationProps> = ({ onLogout }) => {
  const navigate = useNavigate();
  const user = getUser();
  const { t, dir } = useLanguage();

  const handleLogout = () => {
    authAPI.logout();
    onLogout();
    navigate("/login");
  };

  return (
    <Navbar bg="primary" variant="dark" expand="lg" dir={dir}>
      <Container fluid>
        <Navbar.Brand href="/dashboard" className="fw-bold">
          MATA portal
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="main-navbar" />
        <Navbar.Collapse id="main-navbar">
          {/* Right side: language selector, user info, logout */}
          <Nav className="align-items-center gap-2 flex-wrap">
            {/* Language selector — styled to stand out on dark navbar */}
            <div
              style={{
                background: "rgba(255,255,255,0.15)",
                borderRadius: "8px",
                padding: "2px 4px",
              }}
            >
              <LanguageSelector />
            </div>

            <Navbar.Text className="text-white">
              {user?.full_name}
              <span
                className="badge ms-2"
                style={{ background: "rgba(255,255,255,0.25)", color: "#fff" }}
              >
                {user?.role}
              </span>
            </Navbar.Text>

            <Button variant="outline-light" size="sm" onClick={handleLogout}>
              {t("signOut")}
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;
